import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type IsRepairState = boolean;

export const IS_REPAIR = (
  Details: React.ComponentType<ConditionTypeDetailsProps<IsRepairState>>,
): ConditionType<IsRepairState, Condition.IsRepair> => ({
  name: "Is repair",
  description(state) {
    return "Return is for a repair";
  },
  Details(props: ConditionTypeDetailsProps<IsRepairState>) {
    return React.createElement(Details, props);
  },
  empty: false,
  fromModel(model) {
    return true;
  },
  toModel(state) {
    return { type: Condition.IS_REPAIR };
  },
  valid(state) {
    return true;
  },
});
